import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominaDocumentosLayoutsh2hDisponiblesLayout', NominaDocumentosLayoutsh2hDisponiblesLayout)

function NominaDocumentosLayoutsh2hDisponiblesLayout($http) {
  this.get = function (idProyecto, idNomina, idBanco, idMoneda, interbancario) {
    return $http.get('/api/nominas/nomina/documentos/layoutsh2h/disponibles/layout', {
      params: {
        id_proyecto: idProyecto,
        id_nomina: idNomina,
        id_banco: idBanco,
        id_moneda: idMoneda,
        interbancario: interbancario,
      },
      schema: this.schema,
    })
  }.bind(this)

  this.schema = {
    nomina: {
      fecha_nomina: 'date',
      fecha_inicial: 'date',
      fecha_final: 'date',
      fecha_pago: 'date',
      tipo_cambio: 'number',
    },
    colaboradores: {
      id: 'number',
      id_moneda: 'number',
      id_proyecto: 'number',
      id_pago: 'number',
      importe: 'number',
      interbancario: 'boolean',
      tipo_cambio: 'number',
      tipo_cuenta_id: 'number',
      status_aprobado: 'boolean',
      status_pagado: 'boolean',
    }
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Documentos/Layoutsh2h/Disponibles/Layout.js